import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { TextKey } from '@mews-commander/enums';
import ResendEmailForm from '../../../mailing/components/ResendEmailForm';
import { getCheckedReservationIds } from '../../selectors';
import { formCardFactory } from '../formCardFactory';

const ResendEmailFormCard = formCardFactory({
    // @ts-expect-error $TSFixMeError: Type 'unknown' is not assignable to type 'ComponentType<OwnProps & DispatchProps>'.
    FormElement: ResendEmailForm,
    titleTextKey: TextKey.ResendEmail,
    onSuccessMessageKey: TextKey.SendEmailSuccessMessage,
    dataTestId: 'resend-email-form',
});

export default connect(
    createStructuredSelector({
        // @ts-expect-error $TSFixMeError: No overload matches this call.
        reservationIds: getCheckedReservationIds,
    })
)(ResendEmailFormCard);
